import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { SplashMapService } from '../../core/services/splash-map.service';
import { firebase } from '@firebase/app';
import { Constants } from '../../core/config/Constants';
@Component({
  selector: 'app-splash-footer',
  templateUrl: './splash-footer.component.html',
  styleUrls: ['./splash-footer.component.css'],
  providers:[SplashMapService]
})
export class SplashFooterComponent implements OnInit {
  @Input() eventId: string;
  @Input() type: string=null;

  @Output() splashFooterEvent = new EventEmitter<SplashFooterData>();

  imageFile = File;
  uploadFileName:string = null;
  uploadprogress:number = null;
  disableButton:boolean=false;
  message:string=null;
  headerFileUrl: string;
  fileName:string=null;

  splashFooterData = new SplashFooterData();

  constructor(private splashMapService: SplashMapService) { }

  ngOnInit() {
    this.splashMapService.getSplashData(this.eventId).subscribe(event=>{
      if(event) {
       //console.log(event);
       if(event.splash_footer_image_cm_id) {
        this.splashMapService.getFileUrl(this.eventId, event.splash_footer_image_cm_id).subscribe(res => {
          if(res) {
            this.headerFileUrl = res.fileUrl;
            this.fileName = res.filename;
          }
        });
        this.splashFooterData.splash_footer_image_cm_id = event.splash_footer_image_cm_id;
       }
        this.splashFooterData.splash_has_footer_text_top = event.splash_has_footer_text_top;
        this.splashFooterData.splash_has_footer_text_bottom = event.splash_has_footer_text_bottom;
        this.splashFooterData.splash_footer_text_top = event.splash_footer_text_top;
        this.splashFooterData.splash_footer_text_bottom = event.splash_footer_text_bottom;
      }
    });
  }

  onBasicUpload(event) {

    if(event.files[0]) {
      console.log(event.files[0].name);
      this.splashFooterData.fileName = event.files[0].name;
      this.splashFooterEvent.emit(this.splashFooterData);
      let uploadTask = this.splashMapService.uploadFile(this.eventId,event.files[0])
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.splashFooterData.disableButton = false;
          this.uploadFileName = event.files[0].name;
          this.uploadprogress = Math.floor((uploadTask.snapshot.bytesTransferred /uploadTask.snapshot.totalBytes) * 100);
          this.splashFooterData.processing = this.uploadprogress;
          this.splashFooterEvent.emit(this.splashFooterData);
          console.log(this.splashFooterData)
        },
        (error) => {
          this.splashFooterEvent.emit(null);
        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = Constants.CONTENT_M_TYPE_SPLASH;
          contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[0].name;
          contentsMandatory.extension = event.files[0].name.split('.').pop();
          contentsMandatory.sizeInBytes = event.files[0].size;
          console.log(contentsMandatory);
         let key = this.splashMapService.addContentMandatory(contentsMandatory);
         if(key) {
          this.splashFooterData.disableButton = true;
          this.splashFooterData.splash_footer_image_cm_id = key;          
          this.splashFooterEvent.emit(this.splashFooterData);
          setTimeout(function() {
            this.message = null;
          }.bind(this), 1000);
         }
         
        }
      );
    }

  }

  handleFooterChange(e) {
    if(e.target.checked) {
        this.splashFooterData.splash_has_footer_text_top = true;
        this.splashFooterEvent.emit(this.splashFooterData);
    } else {
      this.splashFooterData.splash_has_footer_text_top = false;
      this.splashFooterEvent.emit(this.splashFooterData);
    }
  }
  
  handleFooterChange1(e) {
    if(e.target.checked) {
        this.splashFooterData.splash_has_footer_text_bottom = true;
        this.splashFooterEvent.emit(this.splashFooterData);
    } else {
      this.splashFooterData.splash_has_footer_text_bottom = false;
      this.splashFooterEvent.emit(this.splashFooterData);
    }
  }

  deleteImage() {
    this.uploadFileName = null;
    this.uploadprogress = null;
  }

  getFooterText() {
    this.splashFooterEvent.emit(this.splashFooterData);
  }

}

export class SplashFooterData {
  disableButton:boolean=false;
  fileName:string = null;
  processing: number = 0;
  splash_footer_image_cm_id:string = null;
  splash_has_footer_text_top:boolean = true;
  splash_has_footer_text_bottom:boolean = true;
  splash_footer_text_top:string = null;
  splash_footer_text_bottom:string = null;
}



// WEBPACK FOOTER //
// /app/src/app/layout/splash-footer/splash-footer.component.ts